import {ChecklistRepository} from '../repository/ChecklistRepository';
import {Checklist, ChecklistPayload} from '../models/checklist.model';

export class CreateChecklistUseCase {
  constructor (private checklistRepository: ChecklistRepository) {}

  async execute (payload: ChecklistPayload): Promise<Checklist> {
    return this.checklistRepository.create(payload);
  }
}
